export default __webpack_public_path__ + "static/media/house-19.a1361260.jpg";